import { render } from "./StaffFormLoader.vue?vue&type=template&id=593e916b&scoped=true"
const script = {}

import "./StaffFormLoader.vue?vue&type=style&index=0&id=593e916b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593e916b"]])

export default __exports__